module.exports = __webpack_public_path__ + "static/media/background.abfd1af2.jpg";